import script from "./FooterLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLayout.vue?vue&type=script&setup=true&lang=js"

import "./FooterLayout.vue?vue&type=style&index=0&id=349a757f&lang=scss"

const __exports__ = script;

export default __exports__